(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  if (!mobile.matches) return;

  const root = document.documentElement;
  root.classList.add('fr-chat-deferred');
  let revealed = false;
  const revealChat = () => {
    if (revealed) return;
    revealed = true;
    root.classList.remove('fr-chat-deferred');
    window.removeEventListener('scroll', onScroll);
  };
  const onScroll = () => {
    const height = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
    if (window.scrollY / height >= 0.18) revealChat();
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.setTimeout(revealChat, 12000);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
    document.querySelectorAll('dialog[open]').forEach((dialog) => {
      if (typeof dialog.close === 'function') dialog.close();
    });
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile');
  });
})();

(() => {
  const initProductBar = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    if (document.querySelector('.fr-mobile-product-bar')) return;

    const submit = document.querySelector('product-form .product-form__submit, product-form button[type="submit"]');
    if (!submit) return;

    const title = document.querySelector('.product__title h1');
    const priceRoot = document.querySelector('[id^="price-"]');
    const bar = document.createElement('div');
    bar.className = 'fr-mobile-product-bar';
    bar.setAttribute('aria-label', 'Quick add to cart');
    bar.innerHTML = '<div class="fr-mobile-product-bar__copy"><span class="fr-mobile-product-bar__title"></span><span class="fr-mobile-product-bar__price"></span></div><button class="fr-mobile-product-bar__button" type="button"></button>';
    const barTitle = bar.querySelector('.fr-mobile-product-bar__title');
    const barPrice = bar.querySelector('.fr-mobile-product-bar__price');
    const barButton = bar.querySelector('.fr-mobile-product-bar__button');

    const sync = () => {
      barTitle.textContent = title?.textContent?.trim() || 'Your selection';
      barPrice.textContent = priceRoot?.querySelector('.price-item--sale, .price-item--regular')?.textContent?.trim() || '';
      barButton.textContent = submit.textContent?.trim() || 'Add to cart';
      barButton.disabled = submit.disabled;
    };
    sync();
    document.body.appendChild(bar);
    barButton.addEventListener('click', () => submit.click());

    new MutationObserver(sync).observe(submit, { attributes: true, childList: true, subtree: true });
    if (priceRoot) new MutationObserver(sync).observe(priceRoot, { childList: true, subtree: true });

    new IntersectionObserver(([entry]) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0.2 }).observe(submit);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductBar, { once: true });
  } else {
    initProductBar();
  }
})();

(() => {
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  let unlocked = false;
  const findTawkFrames = () => [...document.querySelectorAll('iframe')].filter((frame) => {
    const style = getComputedStyle(frame);
    const z = Number.parseInt(style.zIndex || '0', 10);
    return frame.getAttribute('src') === 'about:blank' && style.position === 'fixed' && z >= 1000003;
  });
  const applyFloatingWidgetLayout = () => {
    findTawkFrames().forEach((frame) => {
      frame.style.setProperty('bottom', '88px', 'important');
      frame.style.setProperty('opacity', unlocked ? '1' : '0', 'important');
      frame.style.setProperty('pointer-events', unlocked ? 'auto' : 'none', 'important');
    });
    const merchant = document.getElementById('google-merchantwidget-iframe-wrapper');
    if (merchant) merchant.style.setProperty('bottom', '86px', 'important');
    const reviews = document.getElementById('drv-pop-container');
    if (reviews) reviews.style.setProperty('bottom', '86px', 'important');
  };
  const unlock = () => {
    if (unlocked) return;
    unlocked = true;
    applyFloatingWidgetLayout();
    window.removeEventListener('scroll', onScroll);
  };
  const onScroll = () => {
    const height = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
    if (window.scrollY / height >= 0.18) unlock();
  };

  new MutationObserver(applyFloatingWidgetLayout).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'src']
  });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.setTimeout(unlock, 12000);
  applyFloatingWidgetLayout();
})();
